import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import EditorToolbar from "./EditorToolbar";
import EmailPreview from "./EmailPreview";
import ModuleSearchSidebar from "./ModuleSearchSidebar";
import FormatSidebar from "./FormatSidebar";
import ErrorAlert from "../../components/ErrorAlert";

import styles from "./EditEmailPage.module.css";
import { fetchEmail, selectEditorModule } from "../../actions";

export class EditEmailPage extends Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    const { accountId } = this.props.match.params;

    this.props.fetchEmail(accountId, id);
  }

  render() {
    const { accountId } = this.props.match.params;
    const { email } = this.props;

    if (email.failed) {
      return (
        <ErrorAlert title="404">
          <Link to={`/clients/${accountId}/campaigns`}>Return to list</Link>
        </ErrorAlert>
      );
    }

    if (!email.id) {
      return <div />;
    }

    const onSelectDocument = () => {
      this.props.selectEditorModule(false);
    };

    return (
      <div>
        <Helmet>
          <title>Mercury{`${email?.name ? ` - ${email.name}` : ""}`}</title>
        </Helmet>
        <EditorToolbar accountId={accountId} />
        <div className={styles.sidebar}>
          <ModuleSearchSidebar accountId={accountId} />
        </div>
        <div className={styles.centerColumn}>
          <div className={styles.fill} onClick={onSelectDocument} />
          <div className={styles.preview}>
            <EmailPreview accountId={accountId} />
          </div>
        </div>
        <div className={styles.sidebarRight}>
          <FormatSidebar accountId={accountId} />
        </div>
      </div>
    );
  }
}

EditEmailPage.propTypes = {
  params: PropTypes.object,
  fetchEmail: PropTypes.func.isRequired,
  selectEditorModule: PropTypes.func.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { email } = state.editor;
  return {
    email,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  fetchEmail,
  selectEditorModule,
})(EditEmailPage);
